// extracted by mini-css-extract-plugin
export default {"wrap":"Hexagon_wrap__pBZxL","children":"Hexagon_children__tagu2"};